import React, { useState, useEffect, useMemo} from 'react';
import { Form, Button, Collapse } from 'react-bootstrap';
import { useMsal } from "../../Auth/msal-context";
import moment from 'moment';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';

import Auth from "../../Auth/Auth";

const auth = new Auth();

export default function UPDRequest(props){
    const [ isLoading, setIsLoading ] = useState(true);
    const [ collapseAll , setCollapseAll ] = useState(false);
    const [ pendingChangeApprovals, setPendingChangeApprovals ] = useState([]);
    const [ searchQuery, setSearchQuery ] = useState("");

    useEffect(() => {
        getPendingApprovals();
    },[]);

    const getPendingApprovals = async () => {        
        setIsLoading(true);
        let accessToken = await auth.getToken();

        fetch('/api/getUPDChangeRequest', {
            method : "GET",
            headers : {
                'Authorization': "Bearer " + accessToken
            }
        }).then(response => {
            if(response.status !== 200)
            {
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        }).then(data => {
            setPendingChangeApprovals(data);
        }).catch((error) => {
            window.apiError(error);
        });
    };

    const ActionRequest = async (Id, ActionId) => {
        let accessToken = await auth.getToken();

        let comment = null;

        if(ActionId === 4){
            comment = await Swal.fire({
                title: 'Rejection comment',
                html: `Let the requestor know why you're rejecting this`,
                input: 'text',
                showCancelButton: false,
                confirmButtonColor: '#d63043',
                cancelButtonColor: '#aaa',
                confirmButtonText: 'Reject'
              }).then((result) => {
                  if(result.isDismissed){
                      return "Fetch - Rejection Dismissed";
                  }
                  if(result.isConfirmed){
                      if(result.value.length > 0){
                        return result.value;
                      }
                  }                
              });
        }

        if(comment === "Fetch - Rejection Dismissed"){
            return;
        }

        let requestData = {
            RequestId: Id,
            ActionId: ActionId,
            Comment: comment,
        };

        fetch('/api/requestWaveChangeAction', {
            method : "POST",
            headers : {
                'Authorization': "Bearer " + accessToken,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData)
        }).then(response => {
            if(response.status !== 200)
            {
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return  response.json();
        }).then(data => {
            if(data.OutPut.indexOf("Error") > -1){
                toast.error(`👎 ${data.OutPut}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });                     
            } else {
                toast(`😁 ${data.OutPut}`, {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true
                });  
                let arr = pendingChangeApprovals;
                setPendingChangeApprovals(arr.filter(el => el.ClientWaveChangeRequestId !== Id));
            }
        }).catch((error) => {
            window.apiError(error);
        });
    };
    
    const convertToUTC = (dateTime) => {
        return moment.utc(dateTime).format("YYYY/MM/DD");
    };

    return (
        <div id="upd-change-modal">
            <Form.Control value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} style={{border: "1px solid #ced4da"}} placeholder="Search..." />
            {pendingChangeApprovals.map((item,index) => 
                <div className="approval-section" key={index} style={searchQuery.length === 0 || item.Namespace.indexOf(searchQuery) > -1 ? {} : { display: "none" }}>
                    <h4>
                        {item.Namespace} 

                        <div className="approval-btn-container float-right">
                            <Button variant="link" className="text-danger" onClick={() => ActionRequest(item.ClientWaveChangeRequestId,4)}><small>Reject</small></Button>
                            <Button variant="link" onClick={() => ActionRequest(item.ClientWaveChangeRequestId,3)}><small>Approve</small></Button>
                        </div>
                    </h4>
                    <label>Current Wave</label>
                    <p>{item.PriorWave}</p>
                    <label>Current Date</label>
                    <p>{convertToUTC(item.PriorMigrationDate)}</p>

                    <div className={collapseAll ? "mt-4 mb-2 change-request-box d-none" : "mt-4 mb-2 change-request-box"}>
                        <p>Request pending:</p>
                        <label>Requested Wave</label>
                        <p>{item.RequestedWave}</p>
     
                        <label>Requested Date</label>
                        <p>{convertToUTC(item.RequestedMigrationDate)}</p>

                        <label>Requestor</label>
                        <p>{item.SubmittedBy}</p>

                        <label>Requested Change Reason</label>
                        <p>{item.SubmitterComment}</p>
                    </div>
                </div>
            )}

            {pendingChangeApprovals.length === 0 && (
                <p>No Change Requests</p>
            )}
        </div>
    );
}